module.exports = __webpack_public_path__ + "img/3Acredit.471f97a0.png";